export const episodes = [
  {
    id: "ep-01",
    number: 1,
    title: "第1集 · 搬来的邻居",
    tagline: "一栋旧公寓，两户人家的第一次照面",
    synopsis:
      "年轻摄影师志勋搬进老城区的旧公寓，意外发现楼上住着母亲年轻时的旧友秀雅一家。一场突如其来的停电，让两家人第一次坐到同一张餐桌前。",
    story: [
      "初秋的老城区，志勋带着两只行李箱搬进了这栋没有电梯的旧公寓。楼道里堆着旧家具，墙上的灯泡忽明忽暗，房东只留下一句话：楼上的尹家在这住了快二十年，有事可以找他们。",
      "夜里整栋楼突然停电，志勋在漆黑中撞见端着蜡烛下楼的秀雅。她四十多岁，说话很轻，却把每一层楼的住户都记得清清楚楚。烛光里她认出志勋母亲的名字，气氛一下子变得微妙。",
      "来电之后，秀雅坚持留他吃一顿便饭。饭桌上丈夫的沉默、女儿的打量、以及秀雅偶尔避开的目光，让志勋意识到这栋楼里藏着他不知道的旧事。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20Korean%20drama%20poster%20still%2C%20young%20man%20with%20suitcase%20standing%20in%20a%20dim%20old%20apartment%20hallway%2C%20warm%20amber%20lamplight%2C%20deep%20teal%20shadows%2C%20moody%20film%20grain%2C%20melancholic%20atmosphere%2C%20no%20text&width=600&height=900&seq=fm4-cover-01&orientation=portrait",
    duration: "42分钟",
    releaseDate: "2026-06-12",
    status: "已上线",
    tags: ["都市情感", "邻里", "剧情"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-02",
    number: 2,
    title: "第2集 · 楼上的灯",
    tagline: "有些灯亮着，是为了等一个人回家",
    synopsis:
      "志勋开始在深夜听见楼上拖椅子的声音。他借着送还餐盘的机会上楼，看见秀雅独自整理一箱旧照片，其中一张背面写着他母亲的名字。",
    story: [
      "搬来一周，志勋养成了一个习惯：凌晨两点关灯前，看一眼天花板。楼上的灯总会在这个时候熄灭，像一个不肯提前睡去的守夜人。",
      "他借着还餐盘上楼，秀雅家的客厅比想象中更旧，墙上挂着一张二十年前的合影。她解释说那是年轻时在纺织厂拍的，语气平稳，却在他追问母亲时突然沉默。",
      "离开前，志勋在门口看到一张落在地上的照片，背面是他母亲的字迹。他没有问，把照片放回原处，但那一晚他再也没能睡着。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20middle%20aged%20woman%20sitting%20alone%20in%20warm%20lit%20old%20living%20room%20looking%20at%20old%20photographs%2C%20amber%20table%20lamp%20glow%2C%20dark%20window%20behind%20her%2C%20film%20grain%2C%20quiet%20emotion%2C%20no%20text&width=600&height=900&seq=fm4-cover-02&orientation=portrait",
    duration: "41分钟",
    releaseDate: "2026-06-19",
    status: "已上线",
    tags: ["都市情感", "家庭", "悬疑"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
    ],
  },
  {
    id: "ep-03",
    number: 3,
    title: "第3集 · 旧相片",
    tagline: "照片里的人，都还站在原地",
    synopsis:
      "一张二十年前的合影把两个家庭重新连在一起。志勋的母亲在电话里第一次回避了他的问题，而秀雅的丈夫成浩开始对这位新邻居保持警觉。",
    story: [
      "志勋把照片的事告诉母亲，电话那头安静了很久，只回了一句“别去打扰人家”。这句话反而让他更想弄清楚，二十年前那个夏天究竟发生了什么。",
      "秀雅主动约他在楼下的小馆子见面。她说自己年轻时和志勋母亲是同一条流水线上的工友，后来因为一件事断了联系。说到关键处，她却把话咽了回去。",
      "回家的路上，成浩站在楼道口抽烟。他没有发火，只是提醒志勋：这栋楼里的事，最好别问得太深。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20two%20adults%20talking%20across%20a%20small%20warm%20lit%20street%20restaurant%20table%2C%20steam%20from%20food%2C%20amber%20hanging%20lanterns%2C%20dark%20rainy%20street%20outside%2C%20moody%20cinematography%2C%20no%20text&width=600&height=900&seq=fm4-cover-03&orientation=portrait",
    duration: "43分钟",
    releaseDate: "2026-06-26",
    status: "已上线",
    tags: ["都市情感", "悬疑", "剧情"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
    ],
  },
  {
    id: "ep-04",
    number: 4,
    title: "第4集 · 雨夜",
    tagline: "雨把所有没说完的话都留到了屋檐下",
    synopsis:
      "一场暴雨困住晚归的两人。屋檐下的长谈让志勋第一次看见秀雅作为“自己”而非“某人的妻子”的样子，也让他开始怀疑自己的靠近是否恰当。",
    story: [
      "拍摄外景的那天突降暴雨，志勋抱着相机跑回楼下，正遇上没带伞的秀雅。两人挤在窄小的屋檐下，雨水顺着铁皮棚往下淌。",
      "秀雅说起年轻时想去学画画，后来因为家里的安排放弃了。她说这些话时没有抱怨，只是像在讲别人的故事。志勋忽然明白，她这些年一直在替别人活。",
      "雨停之后两人各自上楼。志勋在暗房里冲洗照片，发现画面角落里有一个模糊的身影，正是年轻时的秀雅。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20man%20and%20woman%20standing%20under%20a%20narrow%20eaves%20during%20heavy%20rain%20at%20night%2C%20warm%20streetlight%20reflections%20on%20wet%20pavement%2C%20orange%20and%20dark%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-04&orientation=portrait",
    duration: "42分钟",
    releaseDate: "2026-07-03",
    status: "已上线",
    tags: ["都市情感", "治愈", "剧情"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-05",
    number: 5,
    title: "第5集 · 母亲的电话",
    tagline: "有些沉默，比争吵更响",
    synopsis:
      "母亲突然来到老城区，坚持要志勋搬走。母子之间第一次爆发争吵，秀雅却在这场冲突中选择了后退。",
    story: [
      "母亲没有提前打招呼就出现在公寓门口，手里提着一袋家乡的酱菜。她进门的第一件事是拉开窗帘，看了看对面楼上的窗。",
      "晚饭桌上，母亲提出让志勋搬回家住，理由是他一个人在这边“不像话”。志勋问起二十年前的事，母亲放下筷子，说那是大人的事。",
      "秀雅始终没有出现在这顿饭里。第二天志勋发现门把手上挂着一个保温盒，里面是他小时候爱吃的汤，附了一张纸条：别和家里人赌气。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20older%20woman%20with%20grey%20hair%20standing%20in%20a%20small%20kitchen%20holding%20a%20food%20container%2C%20warm%20morning%20light%20through%20window%2C%20dark%20wood%20cabinets%2C%20restrained%20emotion%2C%20film%20look%2C%20no%20text&width=600&height=900&seq=fm4-cover-05&orientation=portrait",
    duration: "40分钟",
    releaseDate: "2026-07-10",
    status: "已上线",
    tags: ["家庭", "剧情", "都市情感"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "李华顺", role: "饰 志勋母亲" },
    ],
  },
  {
    id: "ep-06",
    number: 6,
    title: "第6集 · 门里的声音",
    tagline: "隔着一扇门，听见完全不同的人生",
    synopsis:
      "深夜的争吵声从楼上传来。志勋第一次直面秀雅婚姻里的裂痕，也被卷入了不该由他承担的立场。",
    story: [
      "凌晨一点，楼上传来摔东西的声音。志勋站在楼梯口犹豫了很久，最终没有上去。第二天秀雅照常下楼倒垃圾，眼角的红被她说成是过敏。",
      "敏珠找到志勋，问他能不能劝劝母亲。她说父亲已经半年没有正经工作了，家里的气氛一天比一天紧。",
      "志勋约秀雅在江边散步，把敏珠的话转述给她。秀雅沉默了很久，只说了一句：我不是没想过走，只是不知道走去哪。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20woman%20sitting%20on%20a%20river%20promenade%20bench%20at%20dusk%20with%20city%20lights%20blurring%20behind%2C%20warm%20orange%20sky%2C%20dark%20silhouette%2C%20lonely%20mood%2C%20cinematic%20photography%2C%20no%20text&width=600&height=900&seq=fm4-cover-06&orientation=portrait",
    duration: "44分钟",
    releaseDate: "2026-07-17",
    status: "已上线",
    tags: ["家庭", "悬疑", "剧情"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "郑敏珠", role: "饰 敏珠" },
      { name: "姜志勋", role: "饰 志勋" },
    ],
  },
  {
    id: "ep-07",
    number: 7,
    title: "第7集 · 医院走廊",
    tagline: "走廊尽头的灯，从来不会为你多亮一秒",
    synopsis:
      "成浩突发疾病住院，秀雅在走廊上守了一夜。志勋送来一壶热水，两人之间第一次出现了无法回避的距离感。",
    story: [
      "成浩在工地晕倒，被送进医院。秀雅翻遍手机通讯录，最后打给了楼下的志勋，请他帮忙接敏珠放学。",
      "医院的走廊很长，塑料椅冰冷。志勋送来一壶热水，坐在她旁边没有说话。秀雅忽然问他：你说人这一辈子，是不是都在还债。",
      "凌晨四点，医生说暂时脱离危险。秀雅靠在墙上哭了几秒，然后擦干脸，说该回去给敏珠准备早饭了。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20empty%20hospital%20corridor%20at%20night%2C%20woman%20sitting%20alone%20on%20plastic%20chair%2C%20cold%20fluorescent%20light%20mixed%20with%20warm%20window%20glow%2C%20long%20perspective%2C%20melancholic%20film%20look%2C%20no%20text&width=600&height=900&seq=fm4-cover-07&orientation=portrait",
    duration: "43分钟",
    releaseDate: "2026-07-24",
    status: "已上线",
    tags: ["家庭", "剧情", "治愈"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-08",
    number: 8,
    title: "第8集 · 两个人的旧账",
    tagline: "他们吵的不是今天，是这二十年",
    synopsis:
      "出院后的成浩开始翻旧账，秀雅终于把这二十年咽下去的话说了出来。志勋在门外听见了全部。",
    story: [
      "成浩出院后变得沉默又易怒。他把工作失意归咎于秀雅当年劝他留在老城区，家里的每一件小事都能变成导火索。",
      "秀雅第一次没有退让。她把这些年的账一笔一笔说清楚：放弃的学画机会、独自照顾的孩子、替他挡下的所有难堪。",
      "志勋站在楼道里，手里拿着想送上去的水果，最终转身回了自己家。他第一次意识到，自己在这件事里其实什么都不是。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20tense%20argument%20between%20a%20man%20and%20woman%20in%20a%20dim%20old%20apartment%2C%20one%20warm%20lamp%20between%20them%2C%20deep%20shadows%2C%20high%20contrast%20dramatic%20lighting%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-08&orientation=portrait",
    duration: "44分钟",
    releaseDate: "2026-07-31",
    status: "已上线",
    tags: ["家庭", "剧情", "悬疑"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
      { name: "姜志勋", role: "饰 志勋" },
    ],
  },
  {
    id: "ep-09",
    number: 9,
    title: "第9集 · 画室",
    tagline: "她终于为自己买了一支笔",
    synopsis:
      "秀雅在志勋的帮助下租下一间小画室，重新拿起画笔。这份迟来的自我让她第一次笑得像个年轻人。",
    story: [
      "志勋工作的影楼缺一个整理底片的人，他顺口问了秀雅。她犹豫了三天，最后说想试试画画，能不能先借用影楼后面的小房间。",
      "她买的第一套颜料并不贵，颜色却挑得很认真。第一次画完整的画时，她画了窗户，窗外是二十年前的纺织厂。",
      "敏珠偷偷去看过那间画室，回来对志勋说，妈妈笑起来的时候，我好像不认识她。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20small%20sunlit%20art%20studio%20with%20easel%20and%20paint%20tubes%2C%20aged%20woman%20painting%20with%20back%20to%20camera%2C%20warm%20golden%20light%20through%20dusty%20window%2C%20hopeful%20mood%2C%20film%20look%2C%20no%20text&width=600&height=900&seq=fm4-cover-09&orientation=portrait",
    duration: "41分钟",
    releaseDate: "2026-08-07",
    status: "已上线",
    tags: ["治愈", "成长", "都市情感"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "姜志勋", role: "饰 志勋" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-10",
    number: 10,
    title: "第10集 · 传开的闲话",
    tagline: "老城区的墙，比想象中更薄",
    synopsis:
      "秀雅频繁出入影楼的事被邻里传成闲话。志勋第一次感受到，所谓的关心有时只是另一种审判。",
    story: [
      "楼下的杂货店老板娘开始用异样的眼神看秀雅。闲话像潮气一样顺着楼道往上爬，传到最后已经面目全非。",
      "成浩在酒桌上听见了版本最难听的那一种。他回家没有吵架，只是把秀雅的画具一件件搬到了阳台上。",
      "志勋想解释，被秀雅拦住了。她说，你越解释，他们越觉得自己说得对。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20narrow%20old%20neighborhood%20alley%20at%20dusk%20with%20hanging%20laundry%2C%20two%20women%20whispering%20in%20the%20background%20out%20of%20focus%2C%20warm%20orange%20window%20lights%2C%20moody%20shadows%2C%20no%20text&width=600&height=900&seq=fm4-cover-10&orientation=portrait",
    duration: "42分钟",
    releaseDate: "2026-08-14",
    status: "已上线",
    tags: ["都市情感", "剧情", "邻里"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
      { name: "姜志勋", role: "饰 志勋" },
    ],
  },
  {
    id: "ep-11",
    number: 11,
    title: "第11集 · 搬家",
    tagline: "有些告别，是先把灯关掉",
    synopsis:
      "秀雅决定搬离这栋住了二十年的公寓。志勋帮她打包时，翻出了那张一直没被解释的照片。",
    story: [
      "秀雅说得很快，像是怕自己改变主意：房子已经找好了，离敏珠的学校近一点，租金也还能负担。",
      "整理旧物时，志勋终于问出了那张照片的来龙去脉。秀雅说，二十年前你母亲要去外地，我借了她一笔钱，后来一直没还上，也没脸联系。",
      "志勋把照片收进自己的相册，说这张我留着。秀雅没有反对，只是把窗户擦得很干净，像要把这二十年一起擦掉。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20cardboard%20moving%20boxes%20in%20a%20half%20empty%20apartment%2C%20woman%20folding%20clothes%20beside%20window%2C%20late%20afternoon%20amber%20light%2C%20dust%20in%20the%20air%2C%20bittersweet%20mood%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-11&orientation=portrait",
    duration: "43分钟",
    releaseDate: "2026-08-21",
    status: "已上线",
    tags: ["家庭", "治愈", "剧情"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "姜志勋", role: "饰 志勋" },
      { name: "李华顺", role: "饰 志勋母亲" },
    ],
  },
  {
    id: "ep-12",
    number: 12,
    title: "第12集 · 空房间",
    tagline: "屋子空了，声音反而更清楚",
    synopsis:
      "楼上彻底安静下来。志勋把母亲请到老城区，两代人隔着一顿晚饭，终于把当年的结解开了一半。",
    story: [
      "秀雅搬走的第三晚，志勋发现自己总是抬头看天花板。那盏曾经凌晨两点还亮着的灯，再也不会亮了。",
      "母亲这次是自己来的，没有提酱菜，也没有提搬家。她站在楼下抬头看了很久，说这家人的窗户以前总擦得很亮。",
      "饭桌上，母亲第一次主动说起从前。她说自己当年也有错，说完就不再开口。志勋给她夹了一筷子菜，什么都没追问。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20empty%20old%20apartment%20room%20with%20single%20wooden%20chair%20and%20curtain%20blowing%2C%20warm%20sunset%20light%20on%20bare%20wall%2C%20quiet%20loneliness%2C%20muted%20dark%20tones%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-12&orientation=portrait",
    duration: "41分钟",
    releaseDate: "2026-08-28",
    status: "已上线",
    tags: ["家庭", "治愈", "剧情"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "李华顺", role: "饰 志勋母亲" },
      { name: "尹秀雅", role: "饰 秀雅" },
    ],
  },
  {
    id: "ep-13",
    number: 13,
    title: "第13集 · 新地址",
    tagline: "门牌号换了，人就真的能重新开始吗",
    synopsis:
      "志勋按着地址找到秀雅的新家，带去她落下的画。新生活并不比旧生活容易，但至少有一扇朝南的窗。",
    story: [
      "新家在城郊的一栋矮楼里，阳台很小，摆着一张折叠桌。秀雅开门时围裙还系着，正在准备晚饭。",
      "志勋把落在旧屋的画送来，那是一幅没画完的窗户。秀雅说画不下去了，因为记不清窗外到底有没有那棵树。",
      "敏珠放学回来，看到志勋很高兴，拉着他看新学校的照片。临走时秀雅送到楼下，说了句谢谢，也说以后不用常来。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20small%20suburban%20balcony%20with%20folding%20table%20and%20potted%20plants%20at%20golden%20hour%2C%20woman%20in%20apron%20standing%20at%20doorway%2C%20warm%20amber%20sunlight%2C%20gentle%20hopeful%20tone%2C%20film%20look%2C%20no%20text&width=600&height=900&seq=fm4-cover-13&orientation=portrait",
    duration: "42分钟",
    releaseDate: "2026-09-04",
    status: "最新更新",
    tags: ["治愈", "都市情感", "成长"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "姜志勋", role: "饰 志勋" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-14",
    number: 14,
    title: "第14集 · 画展",
    tagline: "第一次有人为她的名字停留",
    synopsis:
      "社区画展上，秀雅的三幅作品被挂在最角落的位置。志勋带去了影楼的朋友，也带去了他母亲。",
    story: [
      "画展设在社区活动中心，来的人不多。秀雅的三幅画挂在最靠里的墙边，标签上写着她的本名，字很小。",
      "志勋邀请母亲一起来看。她在画前站了很久，最后说了一句：这些年你画得比以前好了。这是二十年来两人第一次正面说话。",
      "有人在画前驻足，问作者是谁。秀雅愣了一下才举手，那个瞬间她的手在抖。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20small%20community%20art%20exhibition%20wall%20with%20three%20framed%20paintings%2C%20warm%20spotlights%2C%20visitors%20silhouettes%20in%20soft%20focus%2C%20amber%20and%20charcoal%20palette%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-14&orientation=portrait",
    duration: "43分钟",
    releaseDate: "2026-09-11",
    status: "最新更新",
    tags: ["成长", "治愈", "剧情"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "姜志勋", role: "饰 志勋" },
      { name: "李华顺", role: "饰 志勋母亲" },
    ],
  },
  {
    id: "ep-15",
    number: 15,
    title: "第15集 · 回来的路",
    tagline: "绕了二十年，还是回到同一张桌子",
    synopsis:
      "成浩带着一份体检单找到秀雅，两人在新家楼下的面馆坐了一下午。这一次没有人提高声音。",
    story: [
      "成浩没有提前打电话，就出现在新家楼下。他瘦了很多，手里捏着一张体检单，说想谈谈敏珠以后的安排。",
      "面馆里油烟很重，两人隔着塑料桌面对面。成浩第一次承认自己这些年一直在逃避，秀雅没有反驳，也没有原谅。",
      "最后他们把该谈的事谈完了：抚养、房子、以后怎么见面。走出面馆时天已经黑了，成浩说了句对不起，声音很轻。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20two%20middle%20aged%20people%20sitting%20across%20a%20plastic%20table%20in%20a%20small%20noodle%20shop%20at%20night%2C%20warm%20kitchen%20light%2C%20steam%2C%20quiet%20restrained%20emotion%2C%20film%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-15&orientation=portrait",
    duration: "44分钟",
    releaseDate: "2026-09-18",
    status: "最新更新",
    tags: ["家庭", "剧情", "治愈"],
    cast: [
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "朴成浩", role: "饰 成浩" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
  {
    id: "ep-16",
    number: 16,
    title: "第16集 · 窗外的树",
    tagline: "她终于把那扇窗画完了",
    synopsis:
      "在最后一集里，志勋收拾行李准备离开老城区。秀雅交给他一幅画——窗外有一棵树，树下站着年轻时的两个人。",
    story: [
      "志勋接到外地的工作邀约，决定退掉老城区的房子。打包的最后一天，楼上又传来拖椅子的声音，他笑着摇了摇头。",
      "秀雅约他在旧楼下见面，交给他一个卷好的画布。那扇一直画不完的窗终于画完了，窗外有一棵树，树下站着两个年轻的女孩。",
      "两人没有约定以后再见。志勋拖着行李箱走出巷口，回头看了一眼那栋旧楼，四楼的窗户是开着的。",
    ],
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20drama%20poster%20still%2C%20young%20man%20with%20suitcase%20walking%20away%20down%20an%20old%20residential%20alley%20at%20sunset%2C%20open%20window%20of%20old%20building%20glowing%20warm%2C%20long%20shadows%2C%20bittersweet%20farewell%2C%20cinematic%20grain%2C%20no%20text&width=600&height=900&seq=fm4-cover-16&orientation=portrait",
    duration: "45分钟",
    releaseDate: "2026-09-25",
    status: "最新更新",
    tags: ["剧情", "治愈", "成长"],
    cast: [
      { name: "姜志勋", role: "饰 志勋" },
      { name: "尹秀雅", role: "饰 秀雅" },
      { name: "郑敏珠", role: "饰 敏珠" },
    ],
  },
];